import {Component, OnDestroy, OnInit} from '@angular/core';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {StateCountryService} from 'src/app/services/state-country/state-country.service';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {AlertService} from 'src/app/services/alert/alert.service';
import {RatesSroMaster, RateTypes, RateTypesSro, StateCountry} from 'src/app/shared/common-components/common-structure';
import {RateTypesService} from 'src/app/services/rate-types/rate-types.service';
import {RateTypesSroService} from 'src/app/services/rate-types-sro/rate-types-sro.service';
import {RateHhgProcureService} from 'src/app/services/rates-hhg-procure/rate-hhg-procure.service';
import {RatesTspScopeService} from 'src/app/services/rates-tsp-scope/rates-tsp-scope.service';
import {HhgGlobalUpdateStructure} from './hhg-rate-global-update';
import {CarrierService} from 'src/app/services/carrier/carrier.service';
import {UserService} from 'src/app/services/user/user.service';
import {User} from 'src/app/services/user/user';
import {HhgCarrierRateFilingService} from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {takeWhile} from 'rxjs/operators';
import {BehaviorSubject, timer} from 'rxjs';
import AppConstants, {SRO, stateCodes, stateCountry, TransportType as TST, CarrierApprovalInfo as CAI} from '../../shared/common-components/AppConstants';
import {Router} from '@angular/router';

@Component({
    selector: 'app-hhg-rate-global-update',
    templateUrl: './hhg-rate-global-update.component.html',
    styleUrls: ['./hhg-rate-global-update.component.css'],
    standalone: false
})
export class HhgRateGlobalUpdateComponent implements OnInit, OnDestroy {
  rateBidCyclesId: number;
  observer$ = new BehaviorSubject(true);
  isRateFilingClosed$ = new BehaviorSubject(false);

  constructor(
    private fb: UntypedFormBuilder, public loader: LoadingService, private stateCountryService: StateCountryService,
    private alertService: AlertService, private rateTypesService: RateTypesService, private userService: UserService,
    private rateTypesSroService: RateTypesSroService, private carrierService: CarrierService, private router: Router,
    private rateHhgProcureService: RateHhgProcureService, private ratesTspScopeService: RatesTspScopeService,
    private hhgService: HhgCarrierRateFilingService
  ) {
    this.hhgRateGlobalUpdateFilter();
    this.hhgRateGlobalUpdateDiscount();
    this.hhgRateGlobalUpdateAudit();
    this.carrierService.getRateBidCycleId()
      .pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
      this.rateBidCyclesId = res.ratesBidcyclesId;
    });
  }

  // Declared variables
  rateTypeId: number;
  showFieldsOnRateType: Boolean = false;
  carrierId: any;
  sroId: number;
  sroMasterId: number;
  selectedSroId: RatesSroMaster;
  originId: any;
  destinationId: any;
  destinationCount: number;
  originCount: number;
  possibleDestinationCount: number;
  destinationCountText: string;
  disableDiscountCategory: boolean;
  disableOrigin: boolean;
  disableDestinationType: boolean;
  disableDestination: boolean;
  disableOriginType: boolean;
  disableRateType: boolean;
  disableAgencyId: boolean;
  disableTenderId: boolean;
  disableTransportationValue: boolean;
  disablePackLoadDrayageValue: boolean;
  disableWarehouseHandlingValue: boolean;
  disableMonthlyStorageValue: boolean;
  disableDeliveryWithin50MilesValue: boolean;
  disableDeliveryHandlingOutValue: boolean;
  disableCategory1VehicleValue: boolean;
  disableCategory2VehicleValue: boolean;
  disableCategory3VehicleValue: boolean;
  disableClass1Value: boolean;
  disableClass2Value: boolean;
  disableClass3Value: boolean;
  showDiscountFieldsText: boolean;
  showDiscountFieldsAlaskaText: boolean;
  disableStorageInTransitValue: boolean;
  disableAccessorialServicesValue: boolean;
  disableUABValue: boolean;
  originList: StateCountry[];
  destinationList: StateCountry[];
  originList1: StateCountry[];
  ratesList: RateTypes[];
  sroIdList: RatesSroMaster[];
  hhgRateGlobalUpdateFormFilterGroup: UntypedFormGroup;
  hhgRateGlobalUpdateFormDiscountGroup: UntypedFormGroup;
  hhgRateGlobalUpdateFormAuditGroup: UntypedFormGroup;
  result: boolean;
  successCount: number;
  failureCount: number;
  currentUser: User | any;
  discountGroupValid: boolean;
  showUabAccessorials: Boolean = false;
  showGlobalUpdateMessage: Boolean = false;
  showOriginErrorMessage: Boolean = false;
  originErrorMessage = '';
  hideVehicleFieldsForDOSHW: boolean = false;
  transportationError = false;
  transportationErrorMessage = '';
  transportationWarning = false;
  transportationWarningMessage = '';
  sitError = false;
  sitErrorMessage = '';
  sitWarning = false;
  sitWarningMessage = '';
  class1Error = false;
  class1ErrorMessage = '';
  uabError = false;
  uabErrorMessage = '';
  accSvcsError = false;
  accSvcsErrorMessage = '';
  class1Warning = false;
  class1WarningMessage = '';
  class2Error = false;
  class2ErrorMessage = '';
  class2Warning = false;
  class2WarningMessage = '';
  class3Error = false;
  class3ErrorMessage = '';
  class3Warning = false;
  class3WarningMessage = '';
  destinationType: number;
  originType: number;
  tspChoice: boolean;
  discountType1: string[] = [
    'Replace',
    'Increase By %',
    'Decrease By %'
  ];

  discountType2: string[] = [
    'Replace',
    'Increase By',
    'Decrease By'
  ];
  transportTypeFor: string[] = [TST.INTERSTATE, TST.INTERNATIONAL];

  static alaskaStateCodesCondition(val) {
    return val.stateCountryCode === stateCodes.AN || val.stateCountryCode === stateCodes.CV || val.stateCountryCode === stateCodes.FB || val.stateCountryCode === stateCodes.JN ||
      val.stateCountryCode === stateCodes.KN || val.stateCountryCode === stateCodes.KD || val.stateCountryCode === stateCodes.PB || val.stateCountryCode === stateCodes.SA ||
      val.stateCountryCode === stateCodes.WG || val.stateCountryCode === '2200' || val.stateCountryCode === '2201' || val.stateCountryCode === '2202' || val.stateCountryCode === '2203' ||
      val.stateCountryCode === '2204' || val.stateCountryCode === '2205' || val.stateCountryCode === '2206' || val.stateCountryCode === '2207' || val.stateCountryCode === '2208';

  }

  ngOnInit() {
    timer(1000, 1000)
      .pipe(takeWhile(() => !this.isRateFilingClosed$.value))
      .subscribe(val => {
        this.userService.isRateFilingClosed()
          .pipe(takeWhile(() => this.observer$.value))
          .subscribe(res => {
            this.isRateFilingClosed$.next(res);
            if (res) {
              this.alertService.warn('Rate Filing Window has been closed!');
              this.router.navigate(['/', 'landing']);
            }
          });
      });
    this.disableOrigin = true;
    this.disableDestinationType = true;
    this.disableDestination = true;
    this.disableOriginType = true;
    this.disableRateType = true;
    this.disableAgencyId = true;
    this.disableTenderId = true;
    this.result = false;
    this.tspChoice = false;
    this.switchValidatorBasedOnSearch();
    this.disableDiscountGroup();
    this.loader.show();
    this.hhgService.getCarrierIdByUser().subscribe(carrierId => {
      this.carrierId = carrierId;
      this.getCarrierApprovalInfo();
      this.loader.hide();
    }, (error) => {
      this.loader.hide();
      this.alertService.error('Unable to load TSP info values. Please try again later or contact system administrator');
    });
    this.discountGroupValid = false;
    this.hhgRateGlobalUpdateFormDiscountGroup.valueChanges.subscribe(changes => {
      this.discountGroupValid = true;
    });
  }

  getCarrierApprovalInfo() {
    this.hhgService.getCarrierApprovalInfo(this.carrierId).subscribe(carrierApprovalInfo => {
      this.getTransportationType(carrierApprovalInfo);
    }, error => {
      this.alertService.error('TSP Info values are unable to load. Please contact administrator or try again after sometime.');
    });
  }

  getTransportationType(carrierApprovalInfo: any) {
    const carrTypes = carrierApprovalInfo.filter(x => (x.approvalType === CAI.DOMESTICHHG || x.approvalType === CAI.INTERNATIONALHHG));
    let domesticTrans = [false];
    let internationalTrans = false;
    carrTypes.forEach(x => {
      if (x.approvalType === CAI.DOMESTICHHG) {
        if (AppConstants.isNotNullCondition(x.usDotNumber) && (AppConstants.isNotNullCondition(x.ffNumber) || AppConstants.isNotNullCondition(x.mcNumber))) { domesticTrans = [true]; }
      }

      if (x.approvalType === CAI.INTERNATIONALHHG) {
        if (AppConstants.isNotNullCondition(x.ffNumber) || AppConstants.isNotNullCondition(x.mcNumber) || AppConstants.isNotNullCondition(x.fmcOtiNumber)) { internationalTrans = true; }
      }
    });
    domesticTrans.push(internationalTrans);
    const removeTrans: string[] = [TST.INTERSTATE];
    const removeInter: string[] = [TST.INTERNATIONAL];
    if (domesticTrans[0] === false) { this.transportTypeFor = this.transportTypeFor.filter(x => removeTrans.indexOf(x) === -1); }
    if (domesticTrans[1] === false) { this.transportTypeFor = this.transportTypeFor.filter(x => !removeInter.includes(x)); }
  }

  hhgRateGlobalUpdateFilter() {
    this.hhgRateGlobalUpdateFormFilterGroup = this.fb.group({
      transportType: new UntypedFormControl('', Validators.required),
      origin: new UntypedFormControl('', Validators.required),
      destinationsType: new UntypedFormControl('', Validators.required),
      rateType: new UntypedFormControl('', Validators.required),
      agencyId: new UntypedFormControl([], Validators.required),
      tenderId: new UntypedFormControl(''),
      originType: new UntypedFormControl(''),
      destination: new UntypedFormControl('')
    });
  }

  switchValidatorBasedOnSearch() {
    if (!this.tspChoice) {
      this.hhgRateGlobalUpdateFormFilterGroup.get('origin').setValidators(Validators.required);
      this.hhgRateGlobalUpdateFormFilterGroup.get('destinationsType').setValidators(Validators.required);
      this.hhgRateGlobalUpdateFormFilterGroup.get('originType').clearValidators();
      this.hhgRateGlobalUpdateFormFilterGroup.get('destination').clearValidators();
    } else {
      this.hhgRateGlobalUpdateFormFilterGroup.get('originType').setValidators(Validators.required);
      this.hhgRateGlobalUpdateFormFilterGroup.get('destination').setValidators(Validators.required);
      this.hhgRateGlobalUpdateFormFilterGroup.get('origin').clearValidators();
      this.hhgRateGlobalUpdateFormFilterGroup.get('destinationsType').clearValidators();
    }
    this.hhgRateGlobalUpdateFormFilterGroup.controls['originType'].updateValueAndValidity();
    this.hhgRateGlobalUpdateFormFilterGroup.get('destination').updateValueAndValidity();
    this.hhgRateGlobalUpdateFormFilterGroup.get('origin').updateValueAndValidity();
    this.hhgRateGlobalUpdateFormFilterGroup.get('destinationsType').updateValueAndValidity();
  }


  hhgRateGlobalUpdateDiscount() {
    this.hhgRateGlobalUpdateFormDiscountGroup = this.fb.group({
      transportation: new UntypedFormControl(''),
      packLoadDrayage: new UntypedFormControl(''),
      warehouseHandling: new UntypedFormControl(''),
      monthlyStorage: new UntypedFormControl(''),
      deliveryWithin50Miles: new UntypedFormControl(''),
      deliveryHandlingOut: new UntypedFormControl(''),
      category1Vehicle: new UntypedFormControl(''),
      category2Vehicle: new UntypedFormControl(''),
      category3Vehicle: new UntypedFormControl(''),
      class1Vehicle: new UntypedFormControl(''),
      class2Vehicle: new UntypedFormControl(''),
      class3Vehicle: new UntypedFormControl(''),
      storageInTransit: new UntypedFormControl(''),
      accessorialServices: new UntypedFormControl(''),
      UAB: new UntypedFormControl(''),
      transportationValue: new UntypedFormControl(''),
      packLoadDrayageValue: new UntypedFormControl(''),
      warehouseHandlingValue: new UntypedFormControl(''),
      monthlyStorageValue: new UntypedFormControl(''),
      deliveryWithin50MilesValue: new UntypedFormControl(''),
      deliveryHandlingOutValue: new UntypedFormControl(''),
      category1VehicleValue: new UntypedFormControl(''),
      category2VehicleValue: new UntypedFormControl(''),
      category3VehicleValue: new UntypedFormControl(''),
      class1VehicleValue: new UntypedFormControl(''),
      class2VehicleValue: new UntypedFormControl(''),
      class3VehicleValue: new UntypedFormControl(''),
      storageInTransitValue: new UntypedFormControl(''),
      accessorialServicesValue: new UntypedFormControl(''),
      UABValue: new UntypedFormControl(''),
    });
  }

  hhgRateGlobalUpdateAudit() {
    this.hhgRateGlobalUpdateFormAuditGroup = this.fb.group({
      phone: new UntypedFormControl(''),
      email: new UntypedFormControl(''),
    });
  }

  clearUpdateFilter() {
    Object.keys(this.hhgRateGlobalUpdateFormFilterGroup.controls).forEach(key => {
      if (key !== 'transportType') {
        this.hhgRateGlobalUpdateFormFilterGroup.controls[key].setValue('');
      }
    });
  }

  clearUpdateContent() {
    Object.keys(this.hhgRateGlobalUpdateFormDiscountGroup.controls).forEach(key => {
      if (key !== 'class1Vehicle' && key !== 'class2Vehicle' && key !== 'class3Vehicle') {
        this.hhgRateGlobalUpdateFormDiscountGroup.controls[key].setValue('');
      }
    });
  }

  disableDiscountGroup() {
    this.disableDiscountCategory = true;
    this.disableTransportationValue = true;
    this.disablePackLoadDrayageValue = true;
    this.disableWarehouseHandlingValue = true;
    this.disableMonthlyStorageValue = true;
    this.disableDeliveryWithin50MilesValue = true;
    this.disableDeliveryHandlingOutValue = true;
    this.disableCategory3VehicleValue = true;
    this.disableCategory2VehicleValue = true;
    this.disableCategory1VehicleValue = true;
    this.disableClass1Value = true;
    this.disableClass2Value = true;
    this.disableClass3Value = true;
    this.disableUABValue = true;
    this.disableAccessorialServicesValue = true;
    this.disableStorageInTransitValue = true;
  }

  getStateCountryList() {
    if (this.hhgRateGlobalUpdateFormFilterGroup.get('transportType').value === 'Interstate') {
      this.loader.show();
      if (!this.tspChoice) {
        this.stateCountryService.getAllConcorStates().subscribe(stateList => {
          this.originList = stateList;
          this.loader.hide();
        }, error => {
          this.loader.hide();
          this.alertService.error('There was an error retrieving States List');
        });
      } else {
        this.stateCountryService.getAllServiceArea().subscribe(stateList => {
          this.destinationList = stateList;
          this.destinationList.sort((a, b) => {
            return (a.stateCountryName < b.stateCountryName ? -1 : 1);
          });
          this.loader.hide();
        }, error => {
          this.loader.hide();
          this.alertService.error('There was an error retrieving Service Area List');
        });
        this.loader.hide();
      }

    } else if (this.hhgRateGlobalUpdateFormFilterGroup.get('transportType').value === 'International') {
      this.loader.show();
      if (!this.tspChoice) {
        this.stateCountryService.getAll().subscribe(countriesList => {
          this.originList1 = countriesList.filter(country => country.businessType.toLowerCase().indexOf('hhg') > -1);
          this.originList = [];
          this.originList1.forEach(x => {
            if ((x.stateCountryType === 'State' || x.stateCountryType === 'Country') && x.stateCountryCode !== 'AK' && x.stateCountryCode !== 'CA00'
              && x.stateCountryCode !== 'US00' && x.stateCountryCode !== '210H') {
              this.originList.push(x);
            }
          });
          this.originList.sort((a, b) => {
            return (a.stateCountryName < b.stateCountryName ? -1 : 1);
          });
          this.loader.hide();
        }, error => {
          this.loader.hide();
          this.alertService.error('There was an error retrieving Countries List');
        });
      } else {
        this.hhgService.getAllStateCountries().subscribe(res => {
          let stateCountries = (res as StateCountry[]).filter(country => country.businessType.toLowerCase().indexOf('hhg') > -1);
          stateCountries.forEach(x => {
            if (this.canDesArrayConditionUab(x)) {
              x.stateCountryName = x.stateCountryName + ',CANADA';
            }
          });
          stateCountries = stateCountries.filter(x => {
            return ((x.stateCountryCode !== '925E') && (x.stateCountryCode !== '210H') && (x.stateCountryCode !== 'US00')
              && (x.stateCountryCode !== '925S') && (x.stateCountryCode !== 'CA00')
              && (x.stateCountryCode !== 'AK') && (x.stateCountryType !== 'Zone'));
          });
          this.destinationList = stateCountries.filter(x => {
            return ((x.stateCountryCode !== stateCodes.LB && x.stateCountryType !== stateCountry.SERVICEAREA && x.stateCountryCode !== stateCodes.NF
              && x.stateCountryCode !== '9700') && (x.stateCountryType === stateCountry.STATE || x.stateCountryType === stateCountry.COUNTRY));
          });
          this.destinationList.sort((a, b) => {
            return (a.stateCountryName < b.stateCountryName ? -1 : 1);
          });
          this.loader.hide();
        }, error => {
          this.loader.hide();
          this.alertService.error('There was an error retrieving Countries List');
        });
      }

    }
  }

  canDesArrayConditionUab(val) {
    return val.stateCountryCode === '2300' || val.stateCountryCode === '2301' || val.stateCountryCode === '2302' || val.stateCountryCode === '2303' || val.stateCountryCode === '2304' ||
      val.stateCountryCode === '2305' || val.stateCountryCode === '2306' || val.stateCountryCode === '2307' || val.stateCountryCode === '2308' || val.stateCountryCode === '2309' ||
      val.stateCountryCode === '2310' || val.stateCountryCode === '2304' || val.stateCountryCode === '2311' || val.stateCountryCode === '2312' || val.stateCountryCode === '2313';

  }

  getRateTypes() {
    if (this.hhgRateGlobalUpdateFormFilterGroup.get('transportType').value === 'Interstate') {
      this.loader.show();
      this.rateTypesService.getRateTypesListByBusinessTypeAndTransportationType('Domestic').subscribe(domesticRatesTypeList => {
        this.ratesList = domesticRatesTypeList;
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving States List');
      });
    } else if (this.hhgRateGlobalUpdateFormFilterGroup.get('transportType').value === 'International') {
      // const isExtendedStorage = (element) => element.legacyRateType === 11;
      this.loader.show();
      this.rateTypesService.getRateTypesListByBusinessTypeAndTransportationType('International').subscribe(ratesTypeList => {
        // this.ratesList = ratesTypeList.findIndex(isExtendedStorage) === -1 ? ratesTypeList : ratesTypeList.splice(ratesTypeList.findIndex(isExtendedStorage), 1);
        this.ratesList = ratesTypeList;
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving Countries List');
      });
    }
  }

  changeDisableStatus() {
    if (!this.tspChoice) {
      this.disableOrigin = false;
      this.disableDestinationType = true;
      this.disableOriginType = true;
      this.disableDestination = true;
      // this.setValidatorForOriginFirst();
    } else {
      this.disableDestination = false;
      this.disableOriginType = true;
      this.disableOrigin = true;
      this.disableDestinationType = true;
      // this.setValidatorForOriginFirst();
    }
    this.switchValidatorBasedOnSearch();
  }

  onTransportTypeChange($e) {
    this.clearUpdateFilter();
    this.clearUpdateContent();
    this.clearWarningMessages();
    this.changeDisableStatus();
    this.disableRateType = true;
    this.disableAgencyId = true;
    this.disableTenderId = true;
    this.showUabAccessorials = false;
    this.showGlobalUpdateMessage = false;
    this.showDiscountFieldsText = false;
    this.showDiscountFieldsAlaskaText = false;
    this.disableDiscountGroup();
    this.getStateCountryList();
    switch ($e.target.value) {
      case 'Interstate':
        this.showUabAccessorials = false;
        this.showGlobalUpdateMessage = true;
        break;
      case 'International':
        this.showUabAccessorials = true;
        this.showGlobalUpdateMessage = false;
        break;
      default:
        break;
    }
  }

  onOriginChange(originIdValue) {
    this.showDiscountFieldsText = false;
    this.showDiscountFieldsAlaskaText = false;
    this.showOriginErrorMessage = false;
    this.originErrorMessage = '';
    this.hhgRateGlobalUpdateFormFilterGroup.controls['destinationsType'].setValue('');
    this.hhgRateGlobalUpdateFormFilterGroup.controls['rateType'].setValue('');
    this.hhgRateGlobalUpdateFormFilterGroup.controls['agencyId'].setValue('');
    this.hhgRateGlobalUpdateFormFilterGroup.controls['tenderId'].setValue('');
    this.clearUpdateContent();
    this.clearWarningMessages();
    this.disableDestinationType = false;
    this.disableRateType = true;
    this.disableAgencyId = true;
    this.disableTenderId = true;
    this.disableDiscountGroup();
    this.getRateTypes();
    this.originId = originIdValue;
    const origin = this.originList.find(x => x.stateCountryId === parseInt(this.originId));
    const transportType = this.hhgRateGlobalUpdateFormFilterGroup.controls['transportType'].value;
    this.showDiscountFieldsText = (transportType === 'Interstate' || transportType === 'Intrastate') && !HhgRateGlobalUpdateComponent.alaskaStateCodesCondition(origin.stateCountryCode);
    this.showDiscountFieldsAlaskaText = transportType === 'International' || HhgRateGlobalUpdateComponent.alaskaStateCodesCondition(origin.stateCountryCode);
  }

  onDestinationChange(destinationValue: any) {
    this.showDiscountFieldsText = false;
    this.showDiscountFieldsAlaskaText = false;
    this.showOriginErrorMessage = false;
    this.originErrorMessage = '';
    this.hhgRateGlobalUpdateFormFilterGroup.controls['originType'].setValue('');
    this.hhgRateGlobalUpdateFormFilterGroup.controls['rateType'].setValue('');
    this.hhgRateGlobalUpdateFormFilterGroup.controls['agencyId'].setValue('');
    this.hhgRateGlobalUpdateFormFilterGroup.controls['tenderId'].setValue('');
    this.clearUpdateContent();
    this.clearWarningMessages();
    this.disableOriginType = false;
    this.disableRateType = true;
    this.disableAgencyId = true;
    this.disableTenderId = true;
    this.disableDiscountGroup();
    this.getRateTypes();
    this.destinationId = destinationValue;
    const destination = this.destinationList.find(x => x.stateCountryId === parseInt(this.destinationId));
    const transportType = this.hhgRateGlobalUpdateFormFilterGroup.controls['transportType'].value;
    this.showDiscountFieldsText = (transportType === 'Interstate' || transportType === 'Intrastate') && !HhgRateGlobalUpdateComponent.alaskaStateCodesCondition(destination.stateCountryCode);
    this.showDiscountFieldsAlaskaText = transportType === 'International' || HhgRateGlobalUpdateComponent.alaskaStateCodesCondition(destination.stateCountryCode);
  }

  addValidationsForhhgRateGlobalUpdateFormDiscountGroup() {
    this.hhgRateGlobalUpdateFormDiscountGroup.controls['storageInTransit'].setValidators(Validators.required);
    this.hhgRateGlobalUpdateFormDiscountGroup.controls['storageInTransitValue'].setValidators(Validators.required);
    this.hhgRateGlobalUpdateFormDiscountGroup.controls['transportation'].setValidators(Validators.required);
    this.hhgRateGlobalUpdateFormDiscountGroup.controls['transportationValue'].setValidators(Validators.required);
    this.hhgRateGlobalUpdateFormDiscountGroup.controls['category1Vehicle'].setValidators(Validators.required);
    this.hhgRateGlobalUpdateFormDiscountGroup.controls['category1VehicleValue'].setValidators(Validators.required);
    this.hhgRateGlobalUpdateFormDiscountGroup.controls['category2Vehicle'].setValidators(Validators.required);
    this.hhgRateGlobalUpdateFormDiscountGroup.controls['category2VehicleValue'].setValidators(Validators.required);
    this.hhgRateGlobalUpdateFormDiscountGroup.controls['category3Vehicle'].setValidators(Validators.required);
    this.hhgRateGlobalUpdateFormDiscountGroup.controls['category3VehicleValue'].setValidators(Validators.required);
    if (this.hhgRateGlobalUpdateFormFilterGroup.get('transportType').value === 'International') {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['UAB'].setValidators(Validators.required);
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['UABValue'].setValidators(Validators.required);
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['accessorialServices'].setValidators(Validators.required);
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['accessorialServicesValue'].setValidators(Validators.required);
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['UAB'].clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['UABValue'].clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['accessorialServices'].clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['accessorialServicesValue'].clearValidators();
    }
  }

  private syncHiddenFieldValidatorsForDoshw() {
    const allPossibleSelected = this.hhgRateGlobalUpdateFormFilterGroup.get('destinationsType').value === 'All Possible Destinations'
      || this.hhgRateGlobalUpdateFormFilterGroup.get('originType').value === 'All Possible Origins';

    if (this.hideVehicleFieldsForDOSHW) {
      const hiddenControls = [
        'category1Vehicle', 'category1VehicleValue',
        'category2Vehicle', 'category2VehicleValue',
        'category3Vehicle', 'category3VehicleValue',
        'class1Vehicle', 'class1VehicleValue',
        'class2Vehicle', 'class2VehicleValue',
        'class3Vehicle', 'class3VehicleValue',
        'UAB', 'UABValue'
      ];

      hiddenControls.forEach(controlName => {
        this.hhgRateGlobalUpdateFormDiscountGroup.controls[controlName].clearValidators();
        this.hhgRateGlobalUpdateFormDiscountGroup.controls[controlName].updateValueAndValidity({emitEvent: false});
      });
    } else if (allPossibleSelected) {
      this.addValidationsForhhgRateGlobalUpdateFormDiscountGroup();
    }

    this.hhgRateGlobalUpdateFormDiscountGroup.updateValueAndValidity();
  }

  atLeastOneValidator() {
    if ((this.hhgRateGlobalUpdateFormDiscountGroup.get('transportation').value !== '' && this.hhgRateGlobalUpdateFormDiscountGroup.get('transportationValue').value !== '')
      || (this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransit').value !== '' && this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransitValue').value !== '')
      || (this.hhgRateGlobalUpdateFormDiscountGroup.get('category1Vehicle').value !== '' && this.hhgRateGlobalUpdateFormDiscountGroup.get('category1VehicleValue').value !== '')
      || (this.hhgRateGlobalUpdateFormDiscountGroup.get('category2Vehicle').value !== '' && this.hhgRateGlobalUpdateFormDiscountGroup.get('category2VehicleValue').value !== '')
      || (this.hhgRateGlobalUpdateFormDiscountGroup.get('category3Vehicle').value !== '' && this.hhgRateGlobalUpdateFormDiscountGroup.get('category3VehicleValue').value !== '')
      || (this.hhgRateGlobalUpdateFormDiscountGroup.get('UABValue').value !== '' && this.hhgRateGlobalUpdateFormDiscountGroup.get('UAB').value !== '')
      || (this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServices').value !== '' && this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServicesValue').value !== '')
      || (this.hhgRateGlobalUpdateFormAuditGroup.get('phone').value !== '')
      || (this.hhgRateGlobalUpdateFormAuditGroup.get('email').value !== '')
      || (this.hhgRateGlobalUpdateFormFilterGroup.get('tenderId').value !== '')) {
      return true;
    }
    return false;
  }

  onDestinationTypeChange($e) {
    this.hhgRateGlobalUpdateFormDiscountGroup.clearValidators();
    switch ($e.target.value) {
      case 'All Current Destinations':
        this.destinationType = 1;
        this.hhgRateGlobalUpdateFormFilterGroup.controls['tenderId'].setValidators([Validators.minLength(4), Validators.pattern('^[a-zA-Z0-9 \'-]+$')]);
        this.hhgRateGlobalUpdateFormAuditGroup.controls['phone'].clearValidators();
        this.hhgRateGlobalUpdateFormAuditGroup.controls['email'].clearValidators();
        this.hhgRateGlobalUpdateFormAuditGroup.controls['email'].setValidators([Validators.pattern('^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,6})$')]);
        this.hhgRateGlobalUpdateFormAuditGroup.controls['phone'].setValidators([Validators.minLength(10), Validators.maxLength(15)]);
        this.discountType1 = ['Replace', 'Increase By %', 'Decrease By %'];
        this.discountType2 = ['Replace', 'Increase By', 'Decrease By'];
        break;
      case 'All Possible Destinations':
        this.destinationType = 2; // 'All Possible Destinations';
        this.hhgRateGlobalUpdateFormFilterGroup.controls['tenderId'].setValidators([Validators.minLength(4), Validators.pattern('^[a-zA-Z0-9 \'-]+$'), Validators.required]);
        this.hhgRateGlobalUpdateFormAuditGroup.controls['phone'].setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(15)]);
        this.hhgRateGlobalUpdateFormAuditGroup.controls['email'].setValidators([Validators.required, Validators.pattern('^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,6})$')]);
        this.addValidationsForhhgRateGlobalUpdateFormDiscountGroup();
        this.discountType1 = ['Replace'];
        this.discountType2 = ['Replace'];
        break;
      default:
        this.hhgRateGlobalUpdateFormFilterGroup.controls['tenderId'].setValidators([Validators.minLength(4), Validators.pattern('^[a-zA-Z0-9 \'-]+$')]);
        this.hhgRateGlobalUpdateFormAuditGroup.controls['phone'].clearValidators();
        this.hhgRateGlobalUpdateFormAuditGroup.controls['email'].clearValidators();
        this.discountType1 = ['Replace', 'Increase By %', 'Decrease By %'];
        this.discountType2 = ['Replace', 'Increase By', 'Decrease By'];
        break;
    }
    this.hhgRateGlobalUpdateFormDiscountGroup.updateValueAndValidity();
    this.hhgRateGlobalUpdateFormAuditGroup.updateValueAndValidity();
    this.hhgRateGlobalUpdateFormFilterGroup.updateValueAndValidity();
    this.syncHiddenFieldValidatorsForDoshw();
    this.clearUpdateContent();
    this.clearWarningMessages();
    this.hhgRateGlobalUpdateFormFilterGroup.controls['rateType'].setValue('');
    this.hhgRateGlobalUpdateFormFilterGroup.controls['agencyId'].setValue('');
    this.hhgRateGlobalUpdateFormFilterGroup.controls['tenderId'].setValue('');
    this.disableRateType = false;
    this.disableAgencyId = true;
    this.disableTenderId = true;
    this.disableDiscountGroup();
    this.rateTypeId = null;
    this.sroMasterId = null;
    this.destinationCount = 0;
    if (this.hhgRateGlobalUpdateFormFilterGroup.get('destinationsType').value === 'All Current Destinations') {
      this.loader.show();
      this.rateHhgProcureService.getTheCountOfCurrentDestinations(this.rateTypeId, this.carrierId, this.sroMasterId, this.originId, this.rateBidCyclesId, this.destinationType).subscribe(count => {
        if (count !== null && count !== undefined && count === 0) {
          this.alertService.info('There are no records to edit');
          this.hhgRateGlobalUpdateFormFilterGroup.controls['destinationsType'].setValue('');
          this.disableRateType = true;
        } else if (count !== null && count !== undefined && count !== 0) {
          this.destinationCount = count;
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving count for Current Destinations');
      });
    }
  }

  onOriginTypeChange($e) {
    this.hhgRateGlobalUpdateFormDiscountGroup.clearValidators();
    switch ($e.target.value) {
      case 'All Current Origins':
        this.originType = 1;
        this.hhgRateGlobalUpdateFormFilterGroup.controls['tenderId'].setValidators([Validators.minLength(4), Validators.pattern('^[a-zA-Z0-9 \'-]+$')]);
        this.hhgRateGlobalUpdateFormAuditGroup.controls['phone'].clearValidators();
        this.hhgRateGlobalUpdateFormAuditGroup.controls['email'].clearValidators();
        this.hhgRateGlobalUpdateFormAuditGroup.controls['email'].setValidators([ Validators.pattern('^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,6})$')]);
        this.hhgRateGlobalUpdateFormAuditGroup.controls['phone'].setValidators([Validators.minLength(10), Validators.maxLength(15)]);
        this.discountType1 = ['Replace', 'Increase By %', 'Decrease By %'];
        this.discountType2 = ['Replace', 'Increase By', 'Decrease By'];
        break;
      case 'All Possible Origins':
        this.originType = 2; // 'All Possible Destinations';
        this.hhgRateGlobalUpdateFormFilterGroup.controls['tenderId'].setValidators([Validators.minLength(4), Validators.pattern('^[a-zA-Z0-9 \'-]+$'), Validators.required]);
        this.hhgRateGlobalUpdateFormAuditGroup.controls['phone'].setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(15)]);
        this.hhgRateGlobalUpdateFormAuditGroup.controls['email'].setValidators([Validators.required, Validators.pattern('^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,6})$')]);
        this.addValidationsForhhgRateGlobalUpdateFormDiscountGroup();
        this.discountType1 = ['Replace'];
        this.discountType2 = ['Replace'];
        break;
      default:
        this.hhgRateGlobalUpdateFormFilterGroup.controls['tenderId'].setValidators([Validators.minLength(4), Validators.pattern('^[a-zA-Z0-9 \'-]+$')]);
        this.hhgRateGlobalUpdateFormAuditGroup.controls['phone'].clearValidators();
        this.hhgRateGlobalUpdateFormAuditGroup.controls['email'].clearValidators();
        this.discountType1 = ['Replace', 'Increase By %', 'Decrease By %'];
        this.discountType2 = ['Replace', 'Increase By', 'Decrease By'];
        break;
    }
    this.hhgRateGlobalUpdateFormDiscountGroup.updateValueAndValidity();
    this.hhgRateGlobalUpdateFormAuditGroup.updateValueAndValidity();
    this.hhgRateGlobalUpdateFormFilterGroup.updateValueAndValidity();
    this.syncHiddenFieldValidatorsForDoshw();
    this.clearUpdateContent();
    this.clearWarningMessages();
    this.hhgRateGlobalUpdateFormFilterGroup.controls['rateType'].setValue('');
    this.hhgRateGlobalUpdateFormFilterGroup.controls['agencyId'].setValue('');
    this.hhgRateGlobalUpdateFormFilterGroup.controls['tenderId'].setValue('');
    this.disableRateType = false;
    this.disableAgencyId = true;
    this.disableTenderId = true;
    this.disableDiscountGroup();
    this.rateTypeId = null;
    this.sroMasterId = null;
    this.originCount = 0;
    if (this.hhgRateGlobalUpdateFormFilterGroup.get('originType').value === 'All Current Origins') {
      this.loader.show();
      this.rateHhgProcureService.getTheCountOfCurrentOrigins(this.rateTypeId, this.carrierId, this.sroMasterId, this.destinationId, this.rateBidCyclesId, this.originType).subscribe(count => {
        if (count !== null && count !== undefined && count === 0) {
          this.alertService.info('There are no records to edit');
          this.hhgRateGlobalUpdateFormFilterGroup.controls['originType'].setValue('');
          this.disableRateType = true;
        } else if (count !== null && count !== undefined && count !== 0) {
          this.originCount = count;
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving count for Current Origins');
      });
    }
  }

  onRateTypeChange(rateTypeIdValue: number) {
    this.showFieldsOnRateType = false;
    if (['16 - OFM Domestic Drive-away, Tow-away & Carrier-away Services', '17 - International OFM Vehicles']
      .includes(this.hhgRateGlobalUpdateFormFilterGroup.get('rateType').value)) {
      this.showFieldsOnRateType = true;
    }
    this.rateTypeId = rateTypeIdValue;
    this.hhgRateGlobalUpdateFormFilterGroup.controls['agencyId'].setValue('');
    this.hhgRateGlobalUpdateFormFilterGroup.controls['tenderId'].setValue('');
    this.clearUpdateContent();
    this.clearWarningMessages();
    this.disableTenderId = true;
    this.disableDiscountGroup();
    this.sroMasterId = null;
    this.loader.show();
    if (this.tspChoice) {
      this.rateHhgProcureService.getTheCountOfCurrentOrigins(this.rateTypeId, this.carrierId, this.sroMasterId, this.destinationId, this.rateBidCyclesId, this.originType).subscribe(count => {
        if (count !== null && count !== undefined && count === 0) {
          if (this.originType === 2) {
            this.hhgService.getSroByRateTypeAndBidCycle(this.rateTypeId, this.rateBidCyclesId).subscribe(sroIdList => {
              this.sroIdList = sroIdList as RatesSroMaster[];
              this.disableAgencyId = false;
              this.loader.hide();
            }, error => {
              this.loader.hide();
              this.alertService.error('There was an error retrieving sroId List');
            });
          } else {
            this.alertService.info('There are no records to edit');
            this.hhgRateGlobalUpdateFormFilterGroup.controls['rateType'].setValue('');
            this.disableAgencyId = true;
          }
        } else if (count !== null && count !== undefined && count !== 0) {
          this.destinationCount = count;
          this.disableAgencyId = false;
          this.loader.show();
          this.hhgService.getSroByRateTypeAndBidCycle(this.rateTypeId, this.rateBidCyclesId).subscribe(sroIdList => {
            this.sroIdList = sroIdList as RatesSroMaster[];
            this.loader.hide();
          }, error => {
            this.loader.hide();
            this.alertService.error('There was an error retrieving sroId List');
          });
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving count for Current Origins');
      });
    } else {
      this.rateHhgProcureService.getTheCountOfCurrentDestinations(this.rateTypeId, this.carrierId, this.sroMasterId, this.originId, this.rateBidCyclesId, this.destinationType).subscribe(count => {
        if (count !== null && count !== undefined && count === 0) {
          if (this.destinationType === 2) {
            this.hhgService.getSroByRateTypeAndBidCycle(this.rateTypeId, this.rateBidCyclesId).subscribe(sroIdList => {
              this.sroIdList = sroIdList as RatesSroMaster[];
              this.disableAgencyId = false;
              this.loader.hide();
            }, error => {
              this.loader.hide();
              this.alertService.error('There was an error retrieving sroId List');
            });
          } else {
            this.alertService.info('There are no records to edit');
            this.hhgRateGlobalUpdateFormFilterGroup.controls['rateType'].setValue('');
            this.disableAgencyId = true;
          }
        } else if (count !== null && count !== undefined && count !== 0) {
          this.originCount = count;
          this.disableAgencyId = false;
          this.loader.show();
          this.hhgService.getSroByRateTypeAndBidCycle(this.rateTypeId, this.rateBidCyclesId).subscribe(sroIdList => {
            this.sroIdList = sroIdList as RatesSroMaster[];
            this.loader.hide();
          }, error => {
            this.loader.hide();
            this.alertService.error('There was an error retrieving sroId List');
          });
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving count for Current Destinations');
      });
    }
  }

  onAgencyIdChange(sroMasterIdValue) {
    // this.sroMasterId = sroMasterIdValue;
    this.showOriginErrorMessage = false;
    this.originErrorMessage = '';
    this.sroMasterId = this.hhgRateGlobalUpdateFormFilterGroup.get('agencyId').value;
    this.selectedSroId = this.sroIdList.find(sro => sro.sroMasterId === parseInt(this.hhgRateGlobalUpdateFormFilterGroup.get('agencyId').value));
    if (!this.tspChoice) {
      if (this.selectedSroId.sroId === 'OCCDC' && this.hhgRateGlobalUpdateFormFilterGroup.get('transportType').value === 'International') {
        const originSelected = this.originList.find(origin => origin.stateCountryId === parseInt(this.hhgRateGlobalUpdateFormFilterGroup.get('origin').value));
        if (originSelected.stateCountryCode !== '925L' && originSelected.parentCountryId !== 326 && originSelected.parentCountryId !== 365) {
          this.showOriginErrorMessage = true;
          this.originErrorMessage = 'Only 925L - UK - London and Domestic locations are allowed for OCCDC';
        } else {
          this.showOriginErrorMessage = false;
          this.originErrorMessage = '';
        }
      }
      if (this.selectedSroId.sroId === 'DOSSA' && this.hhgRateGlobalUpdateFormFilterGroup.get('transportType').value === 'International') {
        if (this.hhgRateGlobalUpdateFormFilterGroup.get('origin').value !== '280' &&
          this.hhgRateGlobalUpdateFormFilterGroup.get('origin').value !== '316' &&
          this.hhgRateGlobalUpdateFormFilterGroup.get('origin').value !== '262') {
          this.showOriginErrorMessage = true;
          this.originErrorMessage = 'For DOSSA, origin should be only Maryland, Virginia and DC';
        } else {
          this.showOriginErrorMessage = false;
          this.originErrorMessage = '';
        }
      }
      // Hide vehicle fields for DOSHW
      if (this.selectedSroId.sroId === 'DOSHW') {
        this.hideVehicleFieldsForDOSHW = true;
      } else {
        this.hideVehicleFieldsForDOSHW = false;
      }
      this.syncHiddenFieldValidatorsForDoshw();
    }
    this.clearUpdateContent();
    this.clearWarningMessages();
    this.disableDiscountGroup();
    this.disableTenderId = false;
    this.loader.show();
    if (!this.tspChoice) {
      this.rateHhgProcureService.getTheCountOfCurrentDestinationsBySroId(this.rateTypeId, this.carrierId, this.sroMasterId, this.originId, this.rateBidCyclesId).subscribe(count => {
        if (count !== null && count !== undefined && count === 0 && this.destinationType === 1) {
          this.alertService.info('There are no records to edit');
          this.hhgRateGlobalUpdateFormFilterGroup.controls['agencyId'].setValue('');
          this.disableTenderId = true;
        } else if (count !== null && count !== undefined && count !== 0) {
          this.destinationCount = count;
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving count for Current Destinations');
      });
    } else {
      this.rateHhgProcureService.getTheCountOfCurrentOriginsBySroId(this.rateTypeId, this.carrierId, this.sroMasterId, this.destinationId, this.rateBidCyclesId).subscribe(count => {
        if (count !== null && count !== undefined && count === 0 && this.originType === 1) {
          this.alertService.info('There are no records to edit');
          this.hhgRateGlobalUpdateFormFilterGroup.controls['agencyId'].setValue('');
          this.disableTenderId = true;
        } else if (count !== null && count !== undefined && count !== 0) {
          this.originCount = count;
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving count for Current Origins');
      });
    }

    if ((this.hhgRateGlobalUpdateFormFilterGroup.get('destinationsType').value === 'All Possible Destinations')) {
      if (this.hhgRateGlobalUpdateFormFilterGroup.valid) {
        this.disableDiscountCategory = false;
        this.sroMasterId = this.hhgRateGlobalUpdateFormFilterGroup.get('agencyId').value;
      }
    } else {
      this.disableDiscountCategory = false;
    }
  }

  onTenderIdChange() {
    if (this.hhgRateGlobalUpdateFormFilterGroup.get('destinationsType').value === 'All Possible Destinations') {
      if (this.hhgRateGlobalUpdateFormFilterGroup.valid) {
        this.disableDiscountCategory = false;
      }
    } else {
      this.disableDiscountCategory = false;
    }
  }

  //  Discount Functions - Start  //
  onTransportationChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('transportation').value === 'Replace') {
      this.discountsValidation('Transportation', 'Replace',
        this.hhgRateGlobalUpdateFormDiscountGroup.get('transportationValue').value);
    }
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('transportation').value) {
      this.disableTransportationValue = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['transportationValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('transportationValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['transportationValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('transportationValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('transportationValue').updateValueAndValidity();
      this.disableTransportationValue = true;
    }
  }

  onTransportationValueChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('transportation').value === 'Replace') {
      this.discountsValidation('Transportation', 'Replace',
        this.hhgRateGlobalUpdateFormDiscountGroup.get('transportationValue').value);
    }
  }

  onPackLoadDrayageChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('packLoadDrayage').value) {
      this.disablePackLoadDrayageValue = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['packLoadDrayageValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('packLoadDrayageValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['packLoadDrayageValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('packLoadDrayageValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('packLoadDrayageValue').updateValueAndValidity();
      this.disablePackLoadDrayageValue = true;
    }
  }

  onWarehouseHandlingChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('warehouseHandling').value) {
      this.disableWarehouseHandlingValue = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['warehouseHandlingValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('warehouseHandlingValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['warehouseHandlingValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('warehouseHandlingValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('warehouseHandlingValue').updateValueAndValidity();
      this.disableWarehouseHandlingValue = true;
    }
  }

  onMonthlyStorageChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('monthlyStorage').value) {
      this.disableMonthlyStorageValue = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['monthlyStorageValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('monthlyStorageValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['monthlyStorageValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('monthlyStorageValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('monthlyStorageValue').updateValueAndValidity();
      this.disableMonthlyStorageValue = true;
    }
  }

  onDeliveryWithin50MilesChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryWithin50Miles').value) {
      this.disableDeliveryWithin50MilesValue = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['deliveryWithin50MilesValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryWithin50MilesValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['deliveryWithin50MilesValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryWithin50MilesValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryWithin50MilesValue').updateValueAndValidity();
      this.disableDeliveryWithin50MilesValue = true;
    }
  }

  onDeliveryHandlingOutChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryHandlingOut').value) {
      this.disableDeliveryHandlingOutValue = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['deliveryHandlingOutValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryHandlingOutValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['deliveryHandlingOutValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryHandlingOutValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryHandlingOutValue').updateValueAndValidity();
      this.disableDeliveryHandlingOutValue = true;
    }
  }

  onCategory1VehicleChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('category1Vehicle').value === 'Replace') {
      this.discountsValidation('Class1', 'Replace',
        this.hhgRateGlobalUpdateFormDiscountGroup.get('category1VehicleValue').value);
    }
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('category1Vehicle').value) {
      this.disableCategory1VehicleValue = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['category1VehicleValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('category1VehicleValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['category1VehicleValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('category1VehicleValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('category1VehicleValue').updateValueAndValidity();
      this.disableCategory1VehicleValue = true;
    }
  }

  category1VehicleValueChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('category1Vehicle').value === 'Replace') {
      this.discountsValidation('Class1', 'Replace',
        this.hhgRateGlobalUpdateFormDiscountGroup.get('category1VehicleValue').value);
    }
  }

  onCategory2VehicleChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('category2Vehicle').value === 'Replace') {
      this.discountsValidation('Class2', 'Replace',
        this.hhgRateGlobalUpdateFormDiscountGroup.get('category2VehicleValue').value);
    }
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('category2Vehicle').value) {
      this.disableCategory2VehicleValue = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['category2VehicleValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('category2VehicleValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['category2VehicleValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('category2VehicleValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('category2VehicleValue').updateValueAndValidity();
      this.disableCategory2VehicleValue = true;
    }
  }

  category2VehicleValueChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('category2Vehicle').value === 'Replace') {
      this.discountsValidation('Class2', 'Replace',
        this.hhgRateGlobalUpdateFormDiscountGroup.get('category2VehicleValue').value);
    }
  }

  onCategory3VehicleChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('category3Vehicle').value === 'Replace') {
      this.discountsValidation('Class3', 'Replace',
        this.hhgRateGlobalUpdateFormDiscountGroup.get('category3VehicleValue').value);
    }
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('category3Vehicle').value) {
      this.disableCategory3VehicleValue = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['category3VehicleValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('category3VehicleValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['category3VehicleValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('category3VehicleValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('category3VehicleValue').updateValueAndValidity();
      this.disableCategory3VehicleValue = true;
    }
  }

  category3VehicleValueChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('category3Vehicle').value === 'Replace') {
      this.discountsValidation('Class3', 'Replace',
        this.hhgRateGlobalUpdateFormDiscountGroup.get('category3VehicleValue').value);
    }
  }

  onClass1VehicleChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('class1Vehicle').value) {
      this.disableClass1Value = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['class1VehicleValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('class1VehicleValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['class1VehicleValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('class1VehicleValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('class1VehicleValue').updateValueAndValidity();
      this.disableClass1Value = true;
    }
  }

  onClass2VehicleChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('class2Vehicle').value) {
      this.disableClass2Value = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['class2VehicleValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('class2VehicleValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['class2VehicleValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('class2VehicleValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('class2VehicleValue').updateValueAndValidity();
      this.disableClass2Value = true;
    }
  }

  onClass3VehicleChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('class3Vehicle').value) {
      this.disableClass3Value = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['class3VehicleValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('class3VehicleValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['class3VehicleValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('class3VehicleValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('class3VehicleValue').updateValueAndValidity();
      this.disableClass3Value = true;
    }
  }

  onStorageInTransitChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransit').value === 'Replace') {
      this.discountsValidation('SIT', 'Replace',
        this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransitValue').value);
    }
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransit').value) {
      this.disableStorageInTransitValue = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['storageInTransitValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransitValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['storageInTransitValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransitValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransitValue').updateValueAndValidity();
      this.disableStorageInTransitValue = true;
    }
  }

  onStorageInTransitValueChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransit').value === 'Replace') {
      this.discountsValidation('SIT', 'Replace',
        this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransitValue').value);
    }
  }

  onUabValueChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('UAB').value === 'Replace') {
      this.discountsValidation('UAB', 'Replace',
        this.hhgRateGlobalUpdateFormDiscountGroup.get('UABValue').value);
    }
  }

  onAccessorialServicesChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServices').value) {
      this.disableAccessorialServicesValue = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['accessorialServicesValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServicesValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['accessorialServicesValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServicesValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServicesValue').updateValueAndValidity();
      this.disableAccessorialServicesValue = true;
    }
  }

  onAccessorialServicesValueChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServices').value === 'Replace') {
      this.discountsValidation('accSvcs', 'Replace',
        this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServicesValue').value);
    }
  }

  onUABChange() {
    if (this.hhgRateGlobalUpdateFormDiscountGroup.get('UAB').value) {
      this.disableUABValue = false;
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['UABValue'].setValidators([Validators.required]);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('UABValue').updateValueAndValidity();
    } else {
      this.hhgRateGlobalUpdateFormDiscountGroup.controls['UABValue'].setValue(null);
      this.hhgRateGlobalUpdateFormDiscountGroup.get('UABValue').clearValidators();
      this.hhgRateGlobalUpdateFormDiscountGroup.get('UABValue').updateValueAndValidity();
      this.disableUABValue = true;
    }
  }

  discountsValidation(discountType, discount, discountVal) {
    const discountValue = parseInt(discountVal);
    const transportType = this.hhgRateGlobalUpdateFormFilterGroup.get('transportType').value;
    if (discount === 'Replace') {
      switch (discountType) {
        case 'Transportation':
          this.transportationError = false;
          this.transportationErrorMessage = '';
          this.transportationWarning = false;
          this.transportationWarningMessage = '';
          if (discountValue === 0) {
            this.transportationError = true;
            this.transportationErrorMessage = `Linehaul Discount % can\'t be 0 or less than 0`;
          } else if ((discountValue > 60 && discountValue <= 100) && transportType === 'Interstate') {
            this.transportationWarning = true;
            this.transportationWarningMessage = 'Suspected records - Domestic Rates Discounted over 60%.';
          } else if (discountValue < 0 && transportType === 'Interstate') {
            this.transportationWarning = true;
            this.transportationWarningMessage = 'Suspected records - Value negative.';
          } else if (discountValue < 0 && transportType !== 'Interstate') {
            this.transportationError = true;
            this.transportationErrorMessage = `Linehaul Discount % can\'t be negative`;
          } else if (discountValue > 100 && transportType === 'Interstate') {
            this.transportationError = true;
            this.transportationErrorMessage = 'Value cannot exceed 100';
          }
          break;
        case 'SIT':
          this.sitError = false;
          this.sitErrorMessage = '';
          this.sitWarning = false;
          this.sitWarningMessage = '';
          if (discountValue === 0) {
            this.sitError = true;
            this.sitErrorMessage = `Storage In transit cannot be 0 or blank`;
            // if Value > 100
          } else if (discountValue > 100 && transportType !== 'International') {
            this.sitWarning = true;
            this.sitWarningMessage = `Storage In transit cannot be greater than 100`;
          } else if (discountValue < 0 && transportType === 'Interstate') {
            this.sitWarning = true;
            this.sitWarningMessage = `Suspect records - Value Negative.`;
          } else if (discountValue < 0 && transportType !== 'Interstate') {
            this.sitError = true;
            this.sitErrorMessage = `Storage In transit Discount % can\'t be negative`;
          }
          break;
        case 'Class1':
          this.class1Error = false;
          this.class1ErrorMessage = '';
          this.class1Warning = false;
          this.class1WarningMessage = '';
          if (discountValue < 0) {
            this.class1Error = true;
            this.class1ErrorMessage = `Class Vehicle I cannot be negative.`;
          } else if (transportType === 'Interstate' && this.selectedSroId.sroId !== 'FDICC' && discountValue < 30) {
            this.class1Warning = true;
            this.class1WarningMessage = `Suspect records - Category 1 vehicle rate < .30.`;
          } else if (transportType === 'International') {
            if ((this.selectedSroId.sroId === 'DOSHW' || this.selectedSroId.sroId === 'FDICC') && discountVal > 0) {
              this.class1Error = true;
              this.class1ErrorMessage = `Class Vehicle I should be 0.`;
            } else if ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && discountValue === 0) {
              this.class1Error = true;
              this.class1ErrorMessage = `Class Vehicle I cannot be 0 or blank`;
            } else if ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && discountValue < 1000) {
              this.class1Warning = true;
              this.class1WarningMessage = `Suspect records - Category 1 vehicle rate < $1000.00.`;
            } else if ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && discountValue > 20000) {
              this.class1Warning = true;
              this.class1WarningMessage = 'Suspect records - Category 1 vehicle rate > $20000.00.';
            }
          } else if ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && discountValue === 0) {
            this.class1Error = true;
            this.class1ErrorMessage = `Class Vehicle I cannot be 0 or blank`;
          }

          break;
        case 'Class2':
          this.class2Error = false;
          this.class2ErrorMessage = '';
          this.class2Warning = false;
          this.class2WarningMessage = '';
          if (discountValue < 0) {
            this.class2Error = true;
            this.class2ErrorMessage = `Class Vehicle II cannot be negative.`;
          } else if (transportType === 'Interstate' && this.selectedSroId.sroId !== 'FDICC' && discountValue < 30) {
            this.class2Warning = true;
            this.class2WarningMessage = `Suspect records - Class Vehicle II vehicle rate < .30.`;
          } else if (transportType === 'International') {
            if ((this.selectedSroId.sroId === 'DOSHW' || this.selectedSroId.sroId === 'FDICC') && discountVal > 0) {
              this.class2Error = true;
              this.class2ErrorMessage = `Class Vehicle II vehicle should be 0.`;
            } else if ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && discountValue === 0) {
              this.class2Error = true;
              this.class2ErrorMessage = `Class Vehicle II cannot be 0 or blank`;
            } else if ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && discountValue < 1000) {
              this.class2Warning = true;
              this.class2WarningMessage = `Suspect records - Class Vehicle II vehicle rate < $1000.00.`;
            } else if ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && discountValue > 20000) {
              this.class2Warning = true;
              this.class2WarningMessage = 'Suspect records - Class Vehicle II vehicle rate > $20000.00.';
            }
          } else if ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && discountValue === 0) {
            this.class2Error = true;
            this.class2ErrorMessage = `Class Vehicle II Vehicle cannot be 0 or blank`;
          }
          break;
        case 'Class3':
          this.class3Error = false;
          this.class3ErrorMessage = '';
          this.class3Warning = false;
          this.class3WarningMessage = '';
          if (discountValue < 0) {
            this.class3Error = true;
            this.class3ErrorMessage = `Class Vehicle III cannot be negative.`;
          } else if (transportType === 'Interstate' && this.selectedSroId.sroId !== 'FDICC' && discountValue < 30) {
            this.class3Warning = true;
            this.class3WarningMessage = `Suspect records - Class Vehicle III vehicle rate < .30.`;
          } else if (transportType === 'International') {
            if ((this.selectedSroId.sroId === 'DOSHW' || this.selectedSroId.sroId === 'FDICC') && discountVal > 0) {
              this.class3Error = true;
              this.class3ErrorMessage = `Class Vehicle III Vehicle should be 0.`;
            } else if ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && discountValue === 0) {
              this.class3Error = true;
              this.class3ErrorMessage = `Class Vehicle III cannot be 0 or blank`;
            } else if ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && discountValue < 1000) {
              this.class3Warning = true;
              this.class3WarningMessage = `Suspect records - Class Vehicle III vehicle rate < $1000.00.`;
            } else if ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && discountValue > 20000) {
              this.class3Warning = true;
              this.class3WarningMessage = 'Suspect records - Class Vehicle III vehicle rate > $20000.00.';
            }
          } else if ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && discountValue === 0) {
            this.class3Error = true;
            this.class3ErrorMessage = `Class Vehicle III vehicle cannot be 0 or blank`;
          } else if ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && discountValue < 30) {
            this.class3Warning = true;
            this.class3WarningMessage = `Class Vehicle III vehicle cannot be less than 30`;
          }
          break;
        case 'UAB':
          this.uabError = false;
          this.uabErrorMessage = '';
          if (discountValue < 0) {
            this.uabError = true;
            this.uabErrorMessage = `UAB cannot be negative.`;
          } else if (transportType === 'International' && this.selectedSroId.sroId === 'DOSHW' && discountValue > 0) {
            this.uabError = true;
            this.uabErrorMessage = `UAB should be 0.`;
          } else if (transportType === 'International' && this.selectedSroId.sroId === 'DOSSA' && discountValue === 0) {
            this.uabError = true;
            this.uabErrorMessage = `UAB should not be 0 or blank.`;
          }
          break;
        case 'accSvcs':
          if (transportType === 'Interstate') {
            if (this.selectedSroId.sroId !== 'DOSHW' && discountValue !== 0) {
              this.accSvcsError = true;
              this.accSvcsErrorMessage = `For Domestic ACCSRL should be 0 or blank`;
            } else {
              this.emptyAccSvcsError();
            }
          }
          if (transportType === 'International') {
            if ((this.rateTypeId === 9 || this.rateTypeId === 10) && discountValue > 0) {
              this.accSvcsError = true;
              this.accSvcsErrorMessage = `ACC SVCS should be 0`;
              // type!=(9 or 10) and value = zero
            } else if ((this.rateTypeId !== 9 && this.rateTypeId !== 10) && discountValue === 0) {
              this.accSvcsError = true;
              this.accSvcsErrorMessage = `ACC SVCS cannot be 0 or blank`;
            } else {
              this.emptyAccSvcsError();
            }
          } else {
            this.accSvcsError = false;
            this.accSvcsErrorMessage = '';
          }
          break;
        default:
          this.transportationError = false;
          this.transportationErrorMessage = '';
          this.transportationWarning = false;
          this.transportationWarningMessage = '';
          this.sitError = false;
          this.sitErrorMessage = '';
          this.sitWarning = false;
          this.sitWarningMessage = '';
          this.class1Error = false;
          this.class1ErrorMessage = '';
          this.class1Warning = false;
          this.class1WarningMessage = '';
          this.class2Error = false;
          this.class2ErrorMessage = '';
          this.class2Warning = false;
          this.class2WarningMessage = '';
          this.class3Error = false;
          this.class3ErrorMessage = '';
          this.class3Warning = false;
          this.class3WarningMessage = '';
          this.uabError = false;
          this.uabErrorMessage = '';
          break;
      }
    }
  }

  //  Discount Functions - End  //

  /**
   * @description Helper method to return 0 if value is null or contains only spaces
   */
  private getVehicleValue(value: any): any {
    return !value || String(value).trim() === '' ? 0 : value;
  }

  onSave() {
    const globalEditValues: HhgGlobalUpdateStructure = new HhgGlobalUpdateStructure();
    globalEditValues.ratesBidcyclesId = this.rateBidCyclesId;
    // if current destinations selected
    if (!this.tspChoice) {
      if (this.hhgRateGlobalUpdateFormFilterGroup.get('destinationsType').value === 'All Current Destinations'
        || (this.hhgRateGlobalUpdateFormFilterGroup.get('destinationsType').value === 'All Possible Destinations')) {
        globalEditValues.transportType = this.hhgRateGlobalUpdateFormFilterGroup.get('transportType').value;
        globalEditValues.rateTypeId = this.rateTypeId;
        globalEditValues.carrierId = this.carrierId;
        globalEditValues.tenderId = this.hhgRateGlobalUpdateFormFilterGroup.get('tenderId').value;
        globalEditValues.sroMasterIds = this.sroMasterId;
        if (this.hhgRateGlobalUpdateFormFilterGroup.get('destinationsType').value === 'All Possible Destinations') {
          globalEditValues.sroMasterId = this.sroMasterId[0];
        }
        globalEditValues.originId = this.originId;
        globalEditValues.linehaulChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('transportation').value;
        globalEditValues.unaccompaniedAirBagChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('UAB').value;
        globalEditValues.linehaul = this.hhgRateGlobalUpdateFormDiscountGroup.get('transportationValue').value;
        globalEditValues.unaccompaniedAirBag = this.hhgRateGlobalUpdateFormDiscountGroup.get('UABValue').value;
        globalEditValues.bookingEmail = this.hhgRateGlobalUpdateFormAuditGroup.get('email').value;
        globalEditValues.bookingPhone = this.hhgRateGlobalUpdateFormAuditGroup.get('phone').value;
        globalEditValues.updateType = this.hhgRateGlobalUpdateFormFilterGroup.get('destinationsType').value;

        if (this.rateTypeId === 11) {
          globalEditValues.classVehicle1ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('packLoadDrayage').value;
          globalEditValues.classVehicle2ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('warehouseHandling').value;
          globalEditValues.classVehicle3ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('monthlyStorage').value;
          globalEditValues.storageInTransitChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryWithin50Miles').value;
          globalEditValues.accessorialsChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryHandlingOut').value;
          globalEditValues.classVehicle1 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('packLoadDrayageValue').value);
          globalEditValues.classVehicle2 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('warehouseHandlingValue').value);
          globalEditValues.classVehicle3 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('monthlyStorageValue').value);
          globalEditValues.storageInTransit = this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryWithin50MilesValue').value;
          globalEditValues.accessorials = this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryHandlingOutValue').value;
        } else if (this.rateTypeId === 16 || this.rateTypeId === 17) {
          globalEditValues.classVehicle1ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('class1Vehicle').value;
          globalEditValues.classVehicle2ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('class2Vehicle').value;
          globalEditValues.classVehicle3ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('class3Vehicle').value;
          globalEditValues.storageInTransitChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransit').value;
          globalEditValues.accessorialsChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServices').value;
          globalEditValues.classVehicle1 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('class1VehicleValue').value);
          globalEditValues.classVehicle2 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('class2VehicleValue').value);
          globalEditValues.classVehicle3 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('class3VehicleValue').value);
          globalEditValues.storageInTransit = this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransitValue').value;
          globalEditValues.accessorials = this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServicesValue').value;
        } else if (![11, 16, 17].includes(this.rateTypeId)) {
          globalEditValues.classVehicle1ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('category1Vehicle').value;
          globalEditValues.classVehicle2ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('category2Vehicle').value;
          globalEditValues.classVehicle3ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('category3Vehicle').value;
          globalEditValues.storageInTransitChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransit').value;
          globalEditValues.accessorialsChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServices').value;
          globalEditValues.classVehicle1 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('category1VehicleValue').value);
          globalEditValues.classVehicle2 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('category2VehicleValue').value);
          globalEditValues.classVehicle3 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('category3VehicleValue').value);
          globalEditValues.storageInTransit = this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransitValue').value;
          globalEditValues.accessorials = this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServicesValue').value;
        }
      } else {
        if (this.hhgRateGlobalUpdateFormFilterGroup.get('destinationsType').value === 'All Current Destinations') {
          this.alertService.error('Cannot Proceed with Current Destinations Global Update');
        } else {
          this.alertService.error('Cannot Proceed with Count of Possible Destinations Value more than \'1\'');
        }
      }
    } else {
      if (this.hhgRateGlobalUpdateFormFilterGroup.get('originType').value === 'All Current Origins'
        || (this.hhgRateGlobalUpdateFormFilterGroup.get('originType').value === 'All Possible Origins')) {
        globalEditValues.transportType = this.hhgRateGlobalUpdateFormFilterGroup.get('transportType').value;
        globalEditValues.rateTypeId = this.rateTypeId;
        globalEditValues.carrierId = this.carrierId;
        globalEditValues.tenderId = this.hhgRateGlobalUpdateFormFilterGroup.get('tenderId').value;
        globalEditValues.sroMasterIds = this.sroMasterId;
        if (this.hhgRateGlobalUpdateFormFilterGroup.get('originType').value === 'All Possible Origins') {
          globalEditValues.sroMasterId = this.sroMasterId[0];
        }
        globalEditValues.destinationId = this.destinationId;
        globalEditValues.linehaulChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('transportation').value;
        globalEditValues.unaccompaniedAirBagChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('UAB').value;
        globalEditValues.linehaul = this.hhgRateGlobalUpdateFormDiscountGroup.get('transportationValue').value;
        globalEditValues.unaccompaniedAirBag = this.hhgRateGlobalUpdateFormDiscountGroup.get('UABValue').value;
        globalEditValues.bookingEmail = this.hhgRateGlobalUpdateFormAuditGroup.get('email').value;
        globalEditValues.bookingPhone = this.hhgRateGlobalUpdateFormAuditGroup.get('phone').value;
        globalEditValues.updateType = this.hhgRateGlobalUpdateFormFilterGroup.get('originType').value;

        if (this.rateTypeId === 11) {
          globalEditValues.classVehicle1ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('packLoadDrayage').value;
          globalEditValues.classVehicle2ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('warehouseHandling').value;
          globalEditValues.classVehicle3ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('monthlyStorage').value;
          globalEditValues.storageInTransitChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryWithin50Miles').value;
          globalEditValues.accessorialsChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryHandlingOut').value;
          globalEditValues.classVehicle1 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('packLoadDrayageValue').value);
          globalEditValues.classVehicle2 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('warehouseHandlingValue').value);
          globalEditValues.classVehicle3 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('monthlyStorageValue').value);
          globalEditValues.storageInTransit = this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryWithin50MilesValue').value;
          globalEditValues.accessorials = this.hhgRateGlobalUpdateFormDiscountGroup.get('deliveryHandlingOutValue').value;
        } else if (this.rateTypeId === 16 || this.rateTypeId === 17) {
          globalEditValues.classVehicle1ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('class1Vehicle').value;
          globalEditValues.classVehicle2ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('class2Vehicle').value;
          globalEditValues.classVehicle3ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('class3Vehicle').value;
          globalEditValues.storageInTransitChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransit').value;
          globalEditValues.accessorialsChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServices').value;
          globalEditValues.classVehicle1 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('class1VehicleValue').value);
          globalEditValues.classVehicle2 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('class2VehicleValue').value);
          globalEditValues.classVehicle3 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('class3VehicleValue').value);
          globalEditValues.storageInTransit = this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransitValue').value;
          globalEditValues.accessorials = this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServicesValue').value;
        } else if (![11, 16, 17].includes(this.rateTypeId)) {
          globalEditValues.classVehicle1ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('category1Vehicle').value;
          globalEditValues.classVehicle2ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('category2Vehicle').value;
          globalEditValues.classVehicle3ChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('category3Vehicle').value;
          globalEditValues.storageInTransitChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransit').value;
          globalEditValues.accessorialsChangeType = this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServices').value;
          globalEditValues.classVehicle1 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('category1VehicleValue').value);
          globalEditValues.classVehicle2 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('category2VehicleValue').value);
          globalEditValues.classVehicle3 = this.getVehicleValue(this.hhgRateGlobalUpdateFormDiscountGroup.get('category3VehicleValue').value);
          globalEditValues.storageInTransit = this.hhgRateGlobalUpdateFormDiscountGroup.get('storageInTransitValue').value;
          globalEditValues.accessorials = this.hhgRateGlobalUpdateFormDiscountGroup.get('accessorialServicesValue').value;
        }
      } else {
        if (this.hhgRateGlobalUpdateFormFilterGroup.get('originType').value === 'All Current Origins') {
          this.alertService.error('Cannot Proceed with Current Origins Global Update');
        } else {
          this.alertService.error('Cannot Proceed with Count of Possible Origins Value more than \'1\'');
        }
      }
    }

    this.rateHhgProcureService.updateRatesHhgProcure(globalEditValues).subscribe(
      () => {
        this.alertService.information('Your Global Update request is received. You will receive a summary via email.');
        this.hhgRateGlobalUpdateFormFilterGroup.reset();
        this.hhgRateGlobalUpdateFormDiscountGroup.reset();
        this.hhgRateGlobalUpdateFormAuditGroup.reset();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      },
      () => {
        this.alertService.error('There was an error processing your Global Update request. Please try again.');
      }
    );
  }

  /**
   * @description returns true if there are no errors for the validated fields and enables save.
   */
  disableSave() {
    const isCurrentUpdate = this.hhgRateGlobalUpdateFormFilterGroup.get('destinationsType')?.value === 'All Current Destinations'
      || this.hhgRateGlobalUpdateFormFilterGroup.get('originType')?.value === 'All Current Origins';
    const hasVehicleErrors = !this.hideVehicleFieldsForDOSHW
      && (this.class1Error === true || this.class2Error === true || this.class3Error === true);

    if (isCurrentUpdate) {
      return this.transportationError === true
        || this.sitError === true
        || hasVehicleErrors
        || this.showOriginErrorMessage === true
        || !this.atLeastOneValidator();
    }

    const emailValue = this.hhgRateGlobalUpdateFormAuditGroup.get('email')?.value;
    const phoneValue = this.hhgRateGlobalUpdateFormAuditGroup.get('phone')?.value;
    const isEmailMissing = !emailValue || !String(emailValue).trim();
    const isPhoneMissing = !phoneValue || !String(phoneValue).trim();

    return this.transportationError === true
      || this.sitError === true
      || hasVehicleErrors
      || this.showOriginErrorMessage === true
      || isEmailMissing
      || isPhoneMissing;
  }

  clearWarningMessages() {
    this.transportationError = false;
    this.transportationErrorMessage = '';
    this.transportationWarning = false;
    this.transportationWarningMessage = '';
    this.sitError = false;
    this.sitErrorMessage = '';
    this.sitWarning = false;
    this.sitWarningMessage = '';
    this.class1Error = false;
    this.class1ErrorMessage = '';
    this.class1Warning = false;
    this.class1WarningMessage = '';
    this.class2Error = false;
    this.class2ErrorMessage = '';
    this.class2Warning = false;
    this.class2WarningMessage = '';
    this.class3Error = false;
    this.class3ErrorMessage = '';
    this.class3Warning = false;
    this.class3WarningMessage = '';
  }

  /**
   * @description empties the packing discount field warning
   */
  emptyAccSvcsError() {
    this.accSvcsError = false;
    this.accSvcsErrorMessage = '';
  }

  onItemChange(value: any) {
    if (value === 'origin') {
      this.tspChoice = true;
    } else {
      this.tspChoice = false;
    }

    this.changeDisableStatus();
    this.getStateCountryList();
    // Check if DOSHW is selected and hide vehicle fields
    if (this.selectedSroId && this.selectedSroId.sroId === 'DOSHW') {
      this.hideVehicleFieldsForDOSHW = true;
    } else {
      this.hideVehicleFieldsForDOSHW = false;
    }
    this.syncHiddenFieldValidatorsForDoshw();
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }
}
